export const getStepUpChallengeFromError = (error) => {
  const payload = error?.response?.data || {};
  const code = payload.error || '';
  const message = payload.message || error?.message || '';
  const challenge = payload.details?.challenge || null;
  const looksLikeStepUp = /STEP_UP_REQUIRED|SAL|ASSURANCE|2SV|TWO_SV/i.test(`${code} ${message}`);

  // A response can *mention* SAL/assurance language (e.g. 403 SAL_CEILING_EXCEEDED,
  // which is unsatisfiable and carries no challenge) without actually offering a
  // step-up challenge to complete. Only treat this as a step-up when the server
  // gave us a real challenge id to redeem — otherwise fall through to a generic
  // error so callers don't open a StepUpDialog that can never be satisfied.
  if (!looksLikeStepUp || !challenge?.id) {
    return null;
  }

  return {
    id: challenge?.id || '',
    purpose: challenge?.purpose || payload.details?.purpose || '',
    methods: Array.isArray(challenge?.methods) ? challenge.methods : [],
    pushDeviceId: challenge?.pushDeviceId || challenge?.push_device_id || null,
    requiredSal: challenge?.requiredSal || challenge?.required_sal || null,
    expiresAt: challenge?.expiresAt || challenge?.expires_at || null,
    attemptsRemaining: challenge?.attemptsRemaining || challenge?.attempts_remaining || null,
    message: message || 'A fresh second factor is required.',
  };
};

export const isStepUpRequiredError = (error) => Boolean(getStepUpChallengeFromError(error));
